module.exports = __webpack_public_path__ + "static/banner-94d325898a91d3710d2f54bc74b01646.png";